import ReactStars from "react-rating-stars-component";

export function Rating({ ratingValue = 5 }) {
  const ratingChanged = (newRating) => {};
  return (
    <ReactStars
      edit={false}
      value={ratingValue}
      count={5}
      onChange={ratingChanged}
      size={24}
      activeColor="#ffd700"
    />
  );
}
